import { render, staticRenderFns } from "./MyPhoneNumber.vue?vue&type=template&id=28a20eb0&"
import script from "./MyPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./MyPhoneNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports